var map = {
	"./dk/app.js": "OW7N",
	"./dk/chat.js": "CgAq",
	"./dk/connection.js": "iE9o",
	"./dk/game.js": "DA17",
	"./dk/login.js": "gsgs",
	"./en/app.js": "T7rq",
	"./en/chat.js": "zm7d",
	"./en/connection.js": "c+Ht",
	"./en/game.js": "nywV",
	"./en/login.js": "vAUq",
	"./es/app.js": "nAko",
	"./es/chat.js": "16F0",
	"./es/connection.js": "ONf8",
	"./es/game.js": "X1ko",
	"./es/login.js": "KiLP",
	"./it/app.js": "7LGJ",
	"./it/chat.js": "7Ur4",
	"./it/connection.js": "OxQp",
	"./it/game.js": "Ofsg",
	"./it/login.js": "9r/Q",
	"./nl/app.js": "cyUx",
	"./nl/chat.js": "KKV9",
	"./nl/connection.js": "MjvC",
	"./nl/game.js": "pd1h",
	"./nl/login.js": "p8Y4",
	"./pt/app.js": "kbpC",
	"./pt/chat.js": "G1sN",
	"./pt/connection.js": "MZG2",
	"./pt/game.js": "SbhZ",
	"./pt/login.js": "/0Xd",
	"./se/app.js": "KBB+",
	"./se/chat.js": "Ssen",
	"./se/connection.js": "ouxs",
	"./se/game.js": "OUSG",
	"./se/login.js": "U56N"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Nkbb";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages \.js$
// module id = Nkbb
// module chunks = 1